import { NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { trackByValue } from '@recruitee/common';
import {
  ActivitySubscriptionEvent,
  ActivitySubscriptions,
  ActivitySubscriptionType,
  ActivitySubscriptionUpdateData,
} from '@recruitee/http/types';
import { TranslatePipe } from '@recruitee/i18n';
import { BadgeComponent, IconComponent, IconName } from '@recruitee/user-interface';

import { ActivitySubscriptionsTableItemComponent } from './activity-subscriptions-table-item/activity-subscriptions-table-item.component';

@Component({
  selector: 'rt-activity-subscriptions-table-row',
  templateUrl: './activity-subscriptions-table-row.component.html',
  styleUrls: ['./activity-subscriptions-table-row.component.less'],
  host: { class: 'tr' },
  standalone: true,
  imports: [
    IconComponent,
    BadgeComponent,
    NgIf,
    TranslatePipe,
    ActivitySubscriptionsTableItemComponent,
    NgForOf,
  ],
})
export class ActivitySubscriptionsTableRowComponent {
  @Input() public title: string;
  @Input() public icon: IconName;
  @Input() public types: ActivitySubscriptionType[];
  @Input() public eventsGroup: ActivitySubscriptionEvent[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public notifyInfo: boolean;
  @Input() public isNew: boolean = false;
  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();

  public trackByType = trackByValue;
}
